/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal, MinimalNavigation } from '../../../twd'
import MarketNews from '../market-news'

export default () => {
    return <React.Fragment>
    <div
        data-name="corporates-market-news-modal"
        className="modal-dialog"
        style={{
            verticalAlign:'top',
            minWidth: '70%',
        }}
    >
    <div className="modal-content"
    style={{
        background:"#ffffff",
        paddingBottom:'0px'
    }}>

    <MinimalNavigation />

    <div className="row">
    <div className="col-md-3"></div>
    <div className="col-md-6 text-center"><h3 className="medium-header">Corporate Market news</h3></div>
    <div className="col-md-3">
        <div className="vertical-offset-md"></div>
        <button
            className="close"
            aria-label="close"
            data-name="corporates-market-news-modal-close-link"
            type="button"
            onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>
    </div>
    </div>

    <MarketNews modal={true} />

    </div>
    </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/corporates/market-news/modal/market-news-modal.js